export default {
    mask(type) {
        switch (type) {
            case 'date' :
                return '##/##/####';
            case 'datetime' :
                return '##/##/#### ##:##';
            case 'zipcode' :
                return '#####-###';
            case 'cpf' :
                return '###.###.###-##';
            case 'cnpj' :
                return '##.###.###/####-##';
            case 'rg' :
                return ['##.###.###-#', '##.###.###-##', '##.###.###.###-#', '##.###.###.###-##'];
            case 'phone' :
            case 'cellPhone' :
                return ['(##) ####-####', '(##) #####-####'];
            default:
                return false;
        }
    },
}